// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");
require("@fortawesome/fontawesome-free/js/all");
require("select2");

import I18n from 'i18n-js/index.js.erb'
import 'bootstrap';
import * as EasyMDE from 'easymde';
import $ from 'jquery';
import '../stylesheets/application';
import './comment-menu';
import './comment-validation';
import 'select2/dist/css/select2.css';
import './page-form';
import './table-row-redirect';
import './collapsable-page-info';
import './new-tab-wiki-links';
import './page-index-select2'

document.addEventListener('turbolinks:load', () => {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover();
});

window.I18n = I18n
window.EasyMDE = EasyMDE;
global.$ = jQuery;

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
